// A screen with unsaved work can take over the shell's Esc ("back"): it returns true when it handled the key itself
// (for example by asking first).
let guard: (() => boolean) | null = null;
export const setLeaveGuard = (g: (() => boolean) | null) => { guard = g; };
export const leaveGuard = () => (guard ? guard() : false);
